import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addStar, removeStar } from "../features/calls/callsSlice";
import { groupForTalkgroup, groupColorFor, talkgroupNameFor } from "./demoHelpers";

function DemoCallItem({ call, activeCall, talkgroupsData, groupsData, onClick }) {
  const dispatch = useDispatch();
  const showTranscripts = useSelector((s) => s.callPlayer.showTranscripts);
  const [starClicked, setStarClicked] = useState(false);
  const time = new Date(call.time);

  const group = groupForTalkgroup(call.talkgroupNum, groupsData);
  const accent = groupColorFor(group ? group._id : false);
  const tgName = talkgroupNameFor(call.talkgroupNum, talkgroupsData);
  const tags = [...new Set((call.srcList || []).map((s) => s.tag))].filter(Boolean);
  const unitLine = tags.length ? tags.join(", ") : "—";

  const handleStar = (e) => {
    e.preventDefault(); e.stopPropagation();
    if (!starClicked) { setStarClicked(true); dispatch(addStar(call._id)); }
    else { setStarClicked(false); dispatch(removeStar(call._id)); }
  };

  const onDragStart = (event) => {
    event.dataTransfer.setData("call-id", event.currentTarget.dataset.callid);
  };

  return (
    <tr
      className={"demo-row" + (activeCall ? " demo-row-active" : "")}
      data-callid={call._id}
      draggable="true"
      onDragStart={onDragStart}
      onClick={(e) => onClick({ call }, e)}
      style={{ "--row-accent": accent }}
    >
      <td className="demo-row-accent" />
      <td className="demo-row-status">
        {activeCall ? (
          <span className="demo-eq" aria-label="playing"><i /><i /><i /></span>
        ) : !call.played ? (
          <span className="demo-unplayed-dot" />
        ) : null}
      </td>
      <td className="demo-row-main">
        <div className="demo-row-tg">{tgName}</div>
        <div className="demo-row-units demo-mono">{unitLine}</div>
        {showTranscripts && call.transcript && (
          <div className="demo-row-transcript">{call.transcript}</div>
        )}
      </td>
      <td className="demo-row-meta demo-mono">
        <div className="demo-row-time">
          {time.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" })}
        </div>
        <div className="demo-row-len">{call.len}s</div>
      </td>
      <td className="demo-row-star" onClick={handleStar}>
        <span className={call.star ? "demo-star-on" : "demo-star-off"}>
          {call.star ? "★" : "☆"}{call.star > 1 ? ` ${call.star}` : ""}
        </span>
      </td>
    </tr>
  );
}

export default React.memo(DemoCallItem);
